import * as Yup from 'yup';

export const getSignInSchema = () => {
  return Yup.object().shape({
    email: Yup.string()
      .email('Invalid email format')
      .matches(/^[a-zA-Z0-9](.*[a-zA-Z0-9])?$/, 'Invalid email format')
      .required('Email is required'),
    password: Yup.string()
      .min(6, 'Password must be at least 6 characters')
      .matches(
        /^(?=.*[\d!@#$%^&*(),.?":{}|<>]).{6,}$/,
        'Contain at least one number or one special character.',
      )
      .required('Password is required'),
  });
};
